export default __webpack_public_path__ + "static/media/007-catalogue.47ede3d4.svg";